import { axios } from '../../../plugins/axios'

const BASE_PATH = '/PoliciaCuadrantes/DesarrolloPolicial'

export default class RespetoValoresPrincipiosApiRepository {
  async create(payload, idPersonal) {
    const { data } = await axios.post(BASE_PATH + '/personal/' + idPersonal + '/respetoprincipiosvalores', payload)

    return data
  }

  async update(payload, idPersonal, idEvaluacion) {
    const { data } = await axios.put(
      BASE_PATH + '/personal/' + idPersonal + '/respetoprincipiosvalores/' + idEvaluacion,
      payload
    )

    return data
  }

  async updateEstatus(payload, idPersonal, idEvaluacion) {
    const { data } = await axios.put(
      BASE_PATH + '/personal/' + idPersonal + '/respetoprincipiosvalores/' + idEvaluacion + '/estatus',
      {
        fk_idCatEstatusEvaluacion: payload.fk_idCatEstatusEvaluacion,
      }
    )

    return data
  }

  async findById(payload) {
    const { data } = await axios.get(
      BASE_PATH + '/personal/' + payload.idPersonal + '/respetoprincipiosvalores/' + payload.idEvaluacion
    )

    return data.data
  }

  async getEvaluationItems() {
    const { data } = await axios.get(BASE_PATH + '/reactivoValor')

    return data.data
  }
}
